import React, { useState } from 'react';
import Popover from '@/components/ui/Popover';
import I18n from '@/modules/i18n';
import { TCITooltip } from '@/components/ui/Tooltip';
import Icon from '@/components/ui/Icon';
import { findSlideGroupIcon, SLIDE_GROUP_ICONS } from '../../Utils/icons';

const IconSelect = ({ currentIcon, setIcon }) => {
  const [selectedIcon, setSelectedIcon] = useState(currentIcon);

  const handleIconSelect = (icon) => {
    setSelectedIcon(icon);
    setIcon('icon', icon);
  };

  const selected = findSlideGroupIcon(selectedIcon);
  const selectedLabel = selected ? I18n.t(selected.labelKey) : undefined;

  return (
    <div className="tw-flex tw-items-center tw-gap-3 tw-ml-4">
      <div className="tw-border-[1px] tw-border-solid tw-rounded tw-border-[#ccc] tw-shadow-sm tw-flex tw-items-center
      tw-justify-center"
      >
        <Popover>
          <Popover.Trigger
            aria-label={selectedLabel}
            className="tw-cursor-pointer tw-bg-none tw-border-none tw-bg-inherit tw-text-lg tw-flex tw-items-center"
          >
            {selected ? <Icon color="tci-purple" icon={selected.icon} size={30} />
              : (
                <div className="tw-flex tw-items-center tw-gap-2 tw-box-border tw-px-2 tw-min-w-[135px]
                tw-whitespace-nowrap"
                >
                  <span className="tw-text-[#757575] tw-text-[14px]">{I18n.t('select_icon')}</span>
                  <i aria-hidden className="fa fa-caret-down" />
                </div>
              )
            }
          </Popover.Trigger>
          <Popover.Content align="start" className="tw-w-96 tw-flex" side="bottom">
            <div className="tw-px-2">
              <button
                aria-label={I18n.t('clear')}
                className="tw-text-3xl tw-border-none tw-bg-inherit tw-cursor-pointer"
                type="button"
                onClick={() => handleIconSelect(null)}
              >
                <i aria-hidden className="fa fa-times-circle-o tw-text-[#ccc]" />
              </button>
            </div>
            <div className="tw-flex tw-flex-wrap tw-gap-1">
              {SLIDE_GROUP_ICONS.map(({ icon, labelKey }) => (
                <button
                  key={icon}
                  aria-label={I18n.t(labelKey)}
                  className="tw-border-none tw-bg-inherit tw-cursor-pointer tw-text-lg"
                  type="button"
                  onClick={() => handleIconSelect(icon)}
                >
                  <Icon color="tci-purple" icon={icon} size={30} />
                </button>
              ))}
            </div>
          </Popover.Content>
        </Popover>
      </div>
      <TCITooltip>
        <TCITooltip.Trigger asChild>
          <button
            aria-label={I18n.t('help')}
            className="tw-flex tw-items-center tw-p-0 tw-border-none tw-bg-inherit tw-cursor-pointer"
            type="button"
          >
            <i aria-hidden className="fa fa-question-circle" />
          </button>
        </TCITooltip.Trigger>
        <TCITooltip.Content>{I18n.t('icon_select_tooltip')}</TCITooltip.Content>
      </TCITooltip>
    </div>
  );
};

export default IconSelect;
